import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { RealtimeProvider } from "./context/RealtimeContext";
import { SiteContentProvider } from "./context/SiteContentContext";
import { Layout } from "./components/Layout";
import Landing from "./pages/Landing";
import Feed from "./pages/Feed";
import Subscribe from "./pages/Subscribe";
import Cart from "./pages/Cart";
import Profile from "./pages/Profile";
import Friends from "./pages/Friends";
import Messages from "./pages/Messages";
import AdminInbox from "./pages/AdminInbox";
import Help from "./pages/Help";
import Guardian from "./pages/Guardian";
import PostPage from "./pages/PostPage";
import Welcome from "./pages/Welcome";
import Spots from "./pages/Spots";
import SpotDetail from "./pages/SpotDetail";
import Settings from "./pages/Settings";
import SiteEditor from "./pages/SiteEditor";
import GuardianApprove from "./pages/GuardianApprove";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ReportPage from "./pages/ReportPage";
import LegalNameGate from "./components/LegalNameGate";
import VanityResolver from "./pages/VanityResolver";
import SpotlightDen from "./pages/SpotlightDen";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#520202" }}>
      <div className="font-display text-spotter-cream text-4xl animate-pulse">Spotter</div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (user) return <Navigate to="/feed" replace />;
  return children;
}

function Shell() {
  return (
    <RealtimeProvider>
      <Layout />
      <LegalNameGate />
    </RealtimeProvider>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SiteContentProvider>
          <Routes>
            <Route path="/" element={<PublicOnly><Landing /></PublicOnly>} />
          <Route path="/guardian-approve" element={<GuardianApprove />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/report" element={<ReportPage />} />
            <Route element={<Protected><Shell /></Protected>}>
              <Route path="/feed" element={<Feed />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/post/:id" element={<PostPage />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/messages/group/:gid" element={<Messages />} />
              <Route path="/messages/:id" element={<Messages />} />
              <Route path="/admin" element={<AdminInbox />} />
              <Route path="/help" element={<Help />} />
              <Route path="/guardian" element={<Guardian />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/site-editor" element={<SiteEditor />} />
              <Route path="/spots" element={<Spots />} />
              <Route path="/spots/:id" element={<SpotDetail />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/spotlight-den" element={<SpotlightDen />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/u/:handle" element={<Profile />} />
              <Route path="/:handle" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </SiteContentProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
